import { useSyncExternalStore } from "react";
import type { User } from "../api/types";
import { readStore, writeStore } from "../lib/storage";

/** The console's own Superadmin session, apart from any pos-web session on this machine. */
export type Session = { token: string; user: User };
const KEY = "posadmin.session";
const isSession = (v: unknown): v is Session => !!v && typeof v === "object" && typeof (v as Session).token === "string" && typeof (v as Session).user?.userId === "number";

let snap: Session | null = readStore("local", KEY, null, (v): v is Session | null => v === null || isSession(v));
const listeners = new Set<() => void>();

export const sessionStore = {
  get: (): Session | null => snap,
  token: (): string | null => snap?.token ?? null,
  set(s: Session | null): void {
    snap = s;
    writeStore("local", KEY, s);
    listeners.forEach((l) => l());
  },
  subscribe(l: () => void): () => void {
    listeners.add(l);
    return () => listeners.delete(l);
  },
};

if (typeof window !== "undefined")
  window.addEventListener("storage", (e) => {
    if (e.key !== KEY) return;
    snap = readStore("local", KEY, null, (v): v is Session | null => v === null || isSession(v));
    listeners.forEach((l) => l());
  });

export const useSession = (): Session | null => useSyncExternalStore(sessionStore.subscribe, sessionStore.get, sessionStore.get);
